export type USER_TYPE_CONST = 'internal' | 'partime';
export const USER_TYPE_ENUM: {
    [K in USER_TYPE_CONST]: string;
} = {
    internal: '内部用户',
    partime: '兼职用户'
}
export type LOGIN_MODE_CONST = 'account' | 'mobile' | any;
export const FEISHU_ACCESS_URL = "https://open.feishu.cn/open-apis/authen/v1/index?app_id=cli_a4e6913464651013";
export const DD_ACCESS_URL = "https://login.dingtalk.com/oauth2/auth?response_type=code&client_id=ding8wgca92uyxcoie1p&scope=openid&prompt=consent";
export const AUTH_TOKEN_NAME = "shihuo_sso_token";
export const VERSION_TOKEN_NAME = {
    'v1': 'authorization',
    'v2': 'shihuo_sso_token'
}
let baseURL;
let subURL;
let env;
// env = fat: 测试，pre:预发，prod：生产
if (/sso-tst.shihuo.cn/.test(window.location.host) || /localhost/.test(window.location.host)) {
    // baseURL = 'https://sso-tst.shizhi-inc.com';
    baseURL = 'https://sso-tst.shihuo.cn';
    subURL = 'https://sso-tst.shizhi-inc.com';
    env = 'fat';
}
if (/sso-stg.shihuo.cn/.test(window.location.host)) {
    // baseURL = 'https://sso-stg.shizhi-inc.com';
    baseURL = 'https://sso-stg.shihuo.cn';
    subURL = 'https://sso-stg.shizhi-inc.com';
    env = 'pre';
}
if (/sso.shihuo.cn/.test(window.location.host)) {
    // baseURL = 'https://sso.shizhi-inc.com';
    baseURL = 'https://sso.shihuo.cn';
    subURL = 'https://sso.shizhi-inc.com';
    env = 'prod';
}
if (/sso-tst.shizhi-inc.com/.test(window.location.host)) {
    baseURL = 'https://sso-tst.shizhi-inc.com';
    subURL = 'https://sso-tst.shihuo.cn';
    env = 'fat';
}
if (/sso-stg.shizhi-inc.com/.test(window.location.host)) {
    baseURL = 'https://sso-stg.shizhi-inc.com';
    subURL = 'https://sso-stg.shihuo.cn';
    env = 'pre';
}
if (/sso.shizhi-inc.com/.test(window.location.host)) {
    baseURL = 'https://sso.shizhi-inc.com';
    subURL = 'https://sso.shihuo.cn';
    env = 'prod';
}
export const BASE_URL = baseURL;
export const SUB_URL = subURL;
export const ENV = env;
